import React, { useEffect, useState } from "react";
import "./Trophy.css";
import { Modal } from "react-bootstrap";
import { useAuth } from "../../../../../context/LoginContext/AuthContext";
import { useParams } from "react-router-dom";
import BackButton from "../../../Goback/GoBack";
import TrophyCarousel from "./TrophyCarousel";
const apiUrl = process.env.REACT_APP_API_URL;
export const ParentAdminTrophyView = () => {
  const [trophies, setTrophies] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [awardTitle, setawardTitle] = useState("");
  const [selectedTrophy, setSelectedTrophy] = useState(null);
  const { user ,fetchWithAuth} = useAuth();
  const { kidId } = useParams();
  useEffect(() => {
    if (!user || !user.token) {
      return;
    }

    const fetchTrophies = async () => {
      try {
        const response = await fetchWithAuth(`${apiUrl}/student/${kidId}/trophies`, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch trophies");
        }

        const data = await response.json();
        setTrophies(data?.data);
      } catch (err) {
      } finally {
      }
    };

    fetchTrophies();
  }, [user,fetchWithAuth,kidId]); // Dependency added
  const ModalTrophy = () => {
    return (
      <>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
          className="modal-dialog-centered trophy-modal"
        >
          <Modal.Header className="text-white">
            <Modal.Title className="w-100 text-center text-white fs-4">
              {awardTitle}
            </Modal.Title>
            <i className="bi bi-x fs-4" onClick={() => setShowModal(false)}></i>
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center align-items-center p-0">
            <div className="trophy-content">
              {selectedTrophy && (
                <img
                  className="TrphyModalFile"
                  src={selectedTrophy?.trophyFile}
                  alt="award"
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };
  return (
    <>
      <div>
        <div className="StudentAdminBody StudentBodyMrgn">
          
          <div className="container-fluid">
            <div className="mt-4 ml-4">
              <BackButton className="back-btn-white" />
            </div>
            {/* Centered Content */}
            <div className="">
              <div style={{ position: "absolute" }}>
                <img
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/trophy/trophybackground.png"
                  alt="background"
                  className="fullscreen-image"
                />
              </div>
              <div className="text-center center-content">
                <p className="award-text BartenderFont">TROPHIES</p>
                <p className="text-white fs-4">
                  Celebrate Your Learning Journey!
                </p>
              </div>
              <div className="col-md-12 d-none d-md-block awardSection">
                <TrophyCarousel trophies={trophies} />
              </div>
              <div className="container awardSection d-md-none">
                <div className="row justify-content-center">
                  {trophies?.map((trophy, index) => (
                    <div
                      className="col-6 col-md-3 d-flex justify-content-center mb-3 "
                      key={index}
                    >
                      <div className="text-center">
                        <div className="award-container position-relative ">
                          <img
                            src={
                              trophy?.is_awarded
                                ? "https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/trophy/trophycover.png"
                                : "https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/trophy/trophydisable.png"
                            }
                            alt="border"
                            className="img-fluid award-frame w-100"
                            style={{
                              opacity: trophy?.is_awarded ? 1 : 1,
                              filter: trophy?.is_awarded
                                ? "none"
                                : "",
                              transition:
                                "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                            }}
                          />
                          <div className="award-image-wrapper position-absolute top-50 start-50 translate-middle">
                            <img
                              src={trophy?.trophyFile}
                              alt="award"
                              className="img-fluid award-image object-fit-contain"
                              style={{
                                maxWidth: "90%",
                                maxHeight: "90%",
                                opacity: trophy?.is_awarded ? 1 : 0.5,
                                filter: trophy?.is_awarded
                                  ? "none"
                                  : "grayscale(50%)",
                                transition:
                                  "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                              }}
                              onClick={() => {
                                if (trophy?.is_awarded) {
                                  setShowModal(true);
                                  setawardTitle(trophy?.title);
                                  setSelectedTrophy(trophy);
                                }
                              }}
                            />
                            {!trophy?.is_awarded && (
                              <img
                                src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/LockIcon.png"
                                alt="allow"
                                className="img-fluid allow-image object-fit-contain position-absolute"
                                style={{
                                  maxWidth: "50%",
                                  maxHeight: "30%",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                }}
                              />
                            )}
                          </div>
                        </div>{" "}
                        <p
                          className="text-white"
                          style={{ fontSize: "20px", fontWeight: "600" }}
                        >
                          {trophy?.title}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <ModalTrophy />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
